export default "__VITE_ASSET__WUiO8YD$__"